<template>
  <div class="contact">
    <button class="contact__info" @click="$emit('openModal', 'contact_info')"
      aria-label="Button to show contact info"></button>
    <img class="contact__1" src="../assets/static/1.png" />
    <img class="contact__2" src="../assets/static/2.png" v-if="Math.random() >= 0.7" />
    <img class="contact__3" src="../assets/static/3.png" v-if="Math.random() >= 0.5" />
    <img class="contact__4" src="../assets/static/4.png" v-if="Math.random() >= 0.4" />
    <img class="contact__5" src="../assets/static/5.png" v-if="Math.random() >= 0.4" />
    <img class="contact__6" src="../assets/static/6.png" v-if="Math.random() >= 0.3" />
  </div>
</template>

<script>
export default { name: 'Contact' };
</script>

<style lang="scss" scoped>
@import '../tools.mixins';

.contact{
  @include abs(0, 0, 1920px, 1920px);
  transform-origin: 0 0;
  background: url(../assets/bgd/contact.jpg) center no-repeat;
  background-size: cover;

  &__info{
    @include abs(461px, 747px, 394px, 234px);
    @include transparentButton;
    &:hover, &:focus, &:active{
      box-shadow: 0 0 30px 5px #FFF;
    }
  }

  & > img{ pointer-events: none; }
  &__1{ @include abs(705px, 665px, 736px, 705px); z-index: 1; }
  &__2{ @include abs(236px, 738px, 1684px, 1108px); }
  &__3{ @include abs(694px, 827px, 297px, 343px); }
  &__4{ @include abs(730px, 0, 1187px, 889px); z-index: 3; }
  &__5{ @include abs(382px, 154px, 1027px, 599px); z-index: 2; }
  &__6{ @include abs(720px, 710px, 1192px, 560px); z-index: 4; }
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue